import { render } from "./ReportCriterionDateRange.vue?vue&type=template&id=66cb5fdb&scoped=true"
import script from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"
export * from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"

import "./ReportCriterionDateRange.vue?vue&type=style&index=0&id=66cb5fdb&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cb5fdb"]])

export default __exports__